import {Component, Input, OnInit} from '@angular/core';
import {ICryptoWallet} from '@services/crypto-wallet/type';

@Component({
    selector: 'app-crypto-wallet-name',
    templateUrl: './crypto-wallet-name.component.html',
    styleUrls: ['./crypto-wallet-name.component.scss']
})
export class CryptoWalletNameComponent {
    @Input() cryptoWallet: ICryptoWallet;
    constructor() {
    }
}
